module.exports = __webpack_public_path__ + "img/PM_3.9f7598de.svg";